import React, { useEffect } from "react"

const { NODE_ENV } = process.env

var adClass = "";
if (NODE_ENV == 'development') {
  adClass="ad-development";
}

export const AdSide1 = () => { 

  useEffect(() => {
    console.log('running adsbygoogle AdSide1');
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
      <div className="ad-top">
      <div className="d-flex justify-content-center ad-title">
        ADVERTISEMENT
        </div>
      <div className={adClass}
      dangerouslySetInnerHTML={{ __html: `
<!-- ILIR Side 1 -->
<ins class="adsbygoogle"
      style="display:block"
      data-ad-client="ca-pub-2790982044180181"
      data-ad-slot="2892732006"
      data-ad-format="auto"
      data-full-width-responsive="true"></ins>
      `}} />
      </div>
  )
}
//<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2790982044180181"
//      crossorigin="anonymous"></script>

export const AdSide2 = () => {

  useEffect(() => {
    console.log('running adsbygoogle AdSide2');
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
      <div className="ad-bottom">
      <div className={adClass}
      dangerouslySetInnerHTML={{ __html: `
<!-- ILIR Side 2 -->
<ins class="adsbygoogle"
     style="display:block"
     data-ad-client="ca-pub-2790982044180181"
     data-ad-slot="8635179120"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
      `}} />
      </div>
  )
}

export const AdInArtricle = () => {

  useEffect(() => {
    console.log('running adsbygoogle AdInArtricle');
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
      <div className="ad-top ad-bottom mb-2">
      <div className="d-flex justify-content-center ad-title">
        ADVERTISEMENT
        </div>
      <div className={"mb-2 "+adClass}
      dangerouslySetInnerHTML={{ __html: `
 <ins class="adsbygoogle"
      style="display:block; text-align:center;"
      data-ad-layout="in-article"
      data-ad-format="fluid"
      data-ad-client="ca-pub-2790982044180181"
      data-ad-slot="2052834181"></ins>
      `}} />
    </div>
  )
}


export const AdFooter = () => {

  useEffect(() => {
    console.log('running adsbygoogle AdFooter');
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-center ad-title">
        ADVERTISEMENT
        </div>
      <div className={adClass}
      dangerouslySetInnerHTML={{ __html: `
 <!-- ILIR Foot -->
 <ins class="adsbygoogle"
      style="display:block"
      data-ad-client="ca-pub-2790982044180181"
      data-ad-slot="3606924163"
      data-ad-format="auto"
      data-full-width-responsive="true"></ins>
      `}} />
    </div>
  )
}
